import httpClientClubEvents from '../api/httpClientClubEvents';

// Survey CRUD Operations
export const createLiveSurvey = async (payload) => {
  const response = await httpClientClubEvents.post('/api/clubevents/LiveSurvey/Create', payload);
  return response.data;
};

export const updateLiveSurvey = async (payload) => {
  const response = await httpClientClubEvents.put('/api/clubevents/LiveSurvey/Update', payload);
  return response.data;
};

export const deleteLiveSurvey = async (id) => {
  const response = await httpClientClubEvents.delete(`/api/clubevents/LiveSurvey/Delete/${id}`);
  return response.data;
};

export const getLiveSurveyById = async (id) => {
  const response = await httpClientClubEvents.get(`/api/clubevents/LiveSurvey/GetById/${id}`);
  return response.data;
};

export const getAllLiveSurveys = async ({ pageNumber = 1, pageSize = 10 } = {}) => {
  const response = await httpClientClubEvents.get('/api/clubevents/LiveSurvey/GetAll', {
    params: { pageNumber, pageSize },
  });
  return response.data;
};

export const getLiveSurveysByEventId = async (eventId) => {
  const response = await httpClientClubEvents.get(`/api/clubevents/LiveSurvey/GetByEventId/Event/${eventId}`);
  return response.data;
};

// Question Management
export const addQuestion = async (surveyId, payload) => {
  const response = await httpClientClubEvents.post(`/api/clubevents/LiveSurvey/AddQuestion/${surveyId}/Questions`, payload);
  return response.data;
};

export const updateQuestion = async (surveyId, payload) => {
  const response = await httpClientClubEvents.put(`/api/clubevents/LiveSurvey/UpdateQuestion/${surveyId}/Questions`, payload);
  return response.data;
};

export const deleteQuestion = async (surveyId, questionId) => {
  const response = await httpClientClubEvents.delete(`/api/clubevents/LiveSurvey/DeleteQuestion/${surveyId}/Questions/${questionId}`);
  return response.data;
};

export const reorderQuestions = async (surveyId, questionIds) => {
  const response = await httpClientClubEvents.put(`/api/clubevents/LiveSurvey/ReorderQuestions/${surveyId}/Questions/Reorder`, {
    QuestionIds: questionIds,
  });
  return response.data;
};

// Survey Control
export const setSurveyActive = async (surveyId, isActive) => {
  const response = await httpClientClubEvents.put(`/api/clubevents/LiveSurvey/SetActive/${surveyId}/SetActive`, {
    IsActive: isActive,
  });
  return response.data;
};

export const setCurrentQuestion = async (surveyId, questionIndex) => {
  const response = await httpClientClubEvents.put(`/api/clubevents/LiveSurvey/SetCurrentQuestion/${surveyId}/SetCurrentQuestion`, {
    QuestionIndex: questionIndex,
  });
  return response.data;
};

export const nextQuestion = async (surveyId) => {
  const response = await httpClientClubEvents.post(`/api/clubevents/LiveSurvey/NextQuestion/${surveyId}/NextQuestion`);
  return response.data;
};

export const previousQuestion = async (surveyId) => {
  const response = await httpClientClubEvents.post(`/api/clubevents/LiveSurvey/PreviousQuestion/${surveyId}/PreviousQuestion`);
  return response.data;
};

// Report
export const getQuestionReport = async (surveyId, questionId) => {
  const response = await httpClientClubEvents.get(`/api/clubevents/LiveSurvey/GetQuestionReport/${surveyId}/Questions/${questionId}/Report`);
  return response.data;
};

export default {
  createLiveSurvey,
  updateLiveSurvey,
  deleteLiveSurvey,
  getLiveSurveyById,
  getAllLiveSurveys,
  getLiveSurveysByEventId,
  addQuestion,
  updateQuestion,
  deleteQuestion,
  reorderQuestions,
  setSurveyActive,
  setCurrentQuestion,
  nextQuestion,
  previousQuestion,
  getQuestionReport,
};

